import React, { useEffect } from "react";
import TalentCard from "../components/TalentCard";
import AOS from "aos";
import "aos/dist/aos.css";

// ✅ clean Unsplash images (no trailing spaces)
const artist1 = "https://images.unsplash.com/photo-1487215078519-e21cc028cb29";
const artist3 = "https://images.unsplash.com/photo-1511671782779-c97d3d27a1d4";

// ✅ Artist data with real roles and Instagram handles
const artistServices = {
  category: "Artist Management",
  icon: "🎤",
  description:
    "Our focus on specific genres such as the world-renowned AmaPiano and Hip Hop speaks to our niche market as an agency. We provide comprehensive branding, tour management, and career growth opportunities for emerging and established artists.",
  services: [
    "Artist Branding & Image Development",
    "Tour Management & Logistics",
    "Music Production Coordination",
    "Social Media Strategy & Growth",
    "Performance Booking & Negotiation",
    "Contract Negotiation & Legal Support",
    "Music Distribution & Promotion",
    "PR & Media Relations",
  ],
  talents: [
    { 
    name: "Eldridge James", 
    role: "Poet, Musician, Visionary", 
    image: artist1, 
    socials: ["@_eldridgejames"] 
  },
    { 
     name: "Major8ohwait", 
    role: "Hip Hop Artist & Songwriter", 
    image: artist3, 
    socials: ["@major8ohwait"]
    },
  ],
};

const Services = ({ darkTheme = true }) => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  const bgPrimary = darkTheme ? "#0a0a0a" : "#f5f5f5";
  const bgSecondary = darkTheme ? "#111" : "#fff";
  const textPrimary = darkTheme ? "#fff" : "#111";
  const textSecondary = darkTheme ? "#ccc" : "#555";
  const textTertiary = darkTheme ? "#aaa" : "#666";
  const borderColor = darkTheme ? "#222" : "#e5e5e5";
  const cardBg = darkTheme ? "#111" : "#fff";

  return (
    <div style={{ paddingTop: "80px", backgroundColor: darkTheme ? "#0a0a0a" : "#fff" }}>
      {/* HERO SECTION */}
      <section style={{
        padding: "6rem 2rem 4rem",
        backgroundColor: bgPrimary,
        textAlign: "center",
      }}>
        <div>
          <span style={{
            color: "#ff0000",
            fontSize: "0.9rem",
            fontWeight: "600",
            letterSpacing: "2px",
            textTransform: "uppercase",
            display: "block",
            marginBottom: "1rem",
          }} data-aos="fade-down">
            WHAT WE OFFER
          </span>
          <h1 style={{
            fontSize: "3rem",
            fontWeight: "700",
            marginBottom: "1.5rem",
            color: textPrimary,
            lineHeight: "1.2",
          }} data-aos="fade-up">
            Professional Artist Management Services
          </h1>
          <p style={{
            fontSize: "1.2rem",
            color: textTertiary,
            lineHeight: "1.8",
            maxWidth: "900px",
            margin: "0 auto",
          }} data-aos="fade-up" data-aos-delay="100">
            Comprehensive management solutions for AmaPiano, Hip Hop, and RnB artists seeking to elevate their careers
          </p>
        </div>
      </section>

      {/* MAIN SERVICES SECTION */}
      <section style={{
        padding: "5rem 2rem",
        backgroundColor: bgSecondary,
      }}>
        <div style={{ maxWidth: "1400px", margin: "0 auto" }}>
          <div style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: "4rem",
            alignItems: "center",
          }}>
            {/* LEFT SIDE - Info */}
            <div style={{ maxWidth: "600px" }} data-aos="fade-right">
              <div style={{ marginBottom: "1.5rem" }}>
                <span style={{ fontSize: "3.5rem", display: "inline-block" }}>{artistServices.icon}</span>
              </div>
              <h2 style={{
                fontSize: "2.5rem",
                fontWeight: "700",
                marginBottom: "1.5rem",
                color: textPrimary,
              }}>{artistServices.category}</h2>
              <p style={{
                fontSize: "1.1rem",
                lineHeight: "1.8",
                color: textSecondary,
                marginBottom: "2.5rem",
              }}>{artistServices.description}</p>

              <div style={{ marginTop: "2rem" }}>
                <h3 style={{
                  fontSize: "1.3rem",
                  fontWeight: "600",
                  marginBottom: "1.5rem",
                  color: textPrimary,
                }}>Our Services Include:</h3>
                <ul style={{ listStyle: "none", padding: 0 }}>
                  {artistServices.services.map((item, i) => (
                    <li key={i} style={{
                      fontSize: "1rem",
                      color: textSecondary,
                      marginBottom: "1rem",
                      display: "flex",
                      alignItems: "center",
                      gap: "1rem",
                    }}>
                      <span style={{
                        color: "#ff0000",
                        fontSize: "1.2rem",
                        fontWeight: "700",
                      }}>✓</span>
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            {/* RIGHT SIDE - Talent Cards */}
            <div data-aos="fade-left">
              <h3 style={{
                fontSize: "1.5rem",
                fontWeight: "600",
                marginBottom: "2rem",
                color: textPrimary,
              }}>Featured Artists</h3>
              <div style={{
                display: "flex",
                flexDirection: "column",
                gap: "2rem",
              }}>
                {artistServices.talents.map((talent, i) => (
                  <TalentCard key={i} {...talent} darkTheme={darkTheme} />
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* GENRES WE SPECIALIZE IN */}
      <section style={{
        padding: "6rem 2rem",
        backgroundColor: bgPrimary,
      }} data-aos="fade-up">
        <div style={{ maxWidth: "1400px", margin: "0 auto" }}>
          <h2 style={{
            fontSize: "2.5rem",
            fontWeight: "700",
            textAlign: "center",
            marginBottom: "1rem",
            color: textPrimary,
          }}>Genres We Specialize In</h2>
          <p style={{
            fontSize: "1.1rem",
            color: textTertiary,
            textAlign: "center",
            marginBottom: "4rem",
            maxWidth: "700px",
            margin: "0 auto 4rem",
          }}>
            We focus on the hottest genres dominating the African music scene
          </p>
          <div style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
            gap: "2rem",
          }}>
            {[
              {
                genre: "AmaPiano",
                icon: "🎹",
                description: "South Africa's global sensation. We manage AmaPiano artists from emerging talent to established acts.",
              },
              {
                genre: "Hip Hop",
                icon: "🎤",
                description: "From underground rappers to mainstream hip hop artists, we provide comprehensive career management.",
              },
              {
                genre: "RnB",
                icon: "🎵",
                description: "Soulful voices and contemporary RnB artists looking to make their mark in the industry.",
              },
            ].map((item, i) => (
              <div key={i} style={{
                padding: "2.5rem 2rem",
                backgroundColor: cardBg,
                borderRadius: "12px",
                textAlign: "center",
                transition: "all 0.3s ease",
                border: `1px solid ${borderColor}`,
              }} data-aos="zoom-in" data-aos-delay={i * 100}>
                <span style={{
                  fontSize: "3rem",
                  display: "block",
                  marginBottom: "1rem",
                }}>{item.icon}</span>
                <h3 style={{
                  fontSize: "1.5rem",
                  fontWeight: "600",
                  marginBottom: "1rem",
                  color: textPrimary,
                }}>{item.genre}</h3>
                <p style={{
                  fontSize: "1rem",
                  color: textTertiary,
                  lineHeight: "1.7",
                }}>{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* WHY CHOOSE US SECTION */}
      <section style={{
        padding: "6rem 2rem",
        backgroundColor: bgSecondary,
      }} data-aos="fade-up">
        <div style={{ maxWidth: "1400px", margin: "0 auto" }}>
          <h2 style={{
            fontSize: "2.5rem",
            fontWeight: "700",
            textAlign: "center",
            marginBottom: "4rem",
            color: textPrimary,
          }}>Why Choose Faxon Entertainment?</h2>
          <div style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
            gap: "2rem",
          }}>
            {[
              {
                title: "Industry Expertise",
                description: "Deep knowledge of the African music scene and global industry connections",
              },
              {
                title: "Personal Approach",
                description: "Tailored strategies for each artist's unique sound and career goals",
              },
              {
                title: "Global Network",
                description: "Connections with producers, venues, labels, and opportunities worldwide",
              },
              {
                title: "24/7 Support",
                description: "Dedicated team always available for your needs and concerns",
              },
            ].map((benefit, i) => (
              <div key={i} style={{
                padding: "2.5rem 2rem",
                backgroundColor: cardBg,
                borderRadius: "12px",
                textAlign: "center",
                transition: "all 0.3s ease",
                border: `1px solid ${borderColor}`,
              }} data-aos="zoom-in" data-aos-delay={i * 100}>
                <h3 style={{
                  fontSize: "1.3rem",
                  fontWeight: "600",
                  marginBottom: "1rem",
                  color: textPrimary,
                }}>{benefit.title}</h3>
                <p style={{
                  fontSize: "1rem",
                  color: textTertiary,
                  lineHeight: "1.7",
                }}>{benefit.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA SECTION */}
      <section style={{
        padding: "6rem 2rem",
        backgroundColor: "#ff0000",
        textAlign: "center",
      }} data-aos="fade-up">
        <div style={{ maxWidth: "800px", margin: "0 auto" }}>
          <h2 style={{
            fontSize: "2.5rem",
            fontWeight: "700",
            marginBottom: "1.5rem",
            color: "#fff",
          }}>Ready to Take Your Music Career to the Next Level?</h2>
          <p style={{
            fontSize: "1.2rem",
            color: "#fff",
            marginBottom: "2.5rem",
            opacity: 0.95,
          }}>
            Contact us today to discuss how we can help elevate your career as an artist
          </p>
          <a href="/contact" style={{
            display: "inline-block",
            padding: "1.2rem 3rem",
            backgroundColor: "#fff",
            color: "#ff0000",
            borderRadius: "50px",
            textDecoration: "none",
            fontWeight: "700",
            fontSize: "1.1rem",
            letterSpacing: "1px",
            transition: "all 0.3s ease",
            boxShadow: "0 4px 15px rgba(0, 0, 0, 0.3)",
          }}>
            Get in Touch
          </a>
        </div>
      </section>
    </div>
  );
};

export default Services;